module.exports = __webpack_public_path__ + "static/media/sms-iconActive.d58fa4b9.svg";